module.exports = __webpack_public_path__ + "static/media/b1.53f316c1.jpg";